import {
  WS_DAYS,
  WS_ONE_DAY,
  WS_SHIFTS,
  WS_WEEKS,
} from '@pages/WorkSchedule/constants/filters';

import { periodDayCounts } from '@pages/WorkSchedule/data';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

import { createFewDates } from './createFewDates';
import { getDatesByPattern } from './getDatesByPattern';
import { handleSpecificDays } from './handleSpecificDays';

export const getPeriodForSchedule = (
  filters: React.MutableRefObject<NWorkSchedule.Filters>,
  daysCount: string,
  spaceInDays: string,
  startDate: string,
  selectedDays: NWorkSchedule.SelectedDays,
  renderedMonths: NWorkSchedule.RenderedMonths
) => {
  const { primaryPeriod, detailedPeriod } = filters.current.period;
  let period: string[] = [];

  if (primaryPeriod === WS_DAYS) {
    period = createFewDates(
      startDate,
      detailedPeriod !== WS_ONE_DAY
        ? periodDayCounts.find(({ id }) => id === detailedPeriod)?.daysCount ||
            7
        : 1
    );
  } else if (primaryPeriod === WS_SHIFTS) {
    period = getDatesByPattern({
      mode: WS_SHIFTS,
      pattern: {
        daysCount: Number(daysCount),
        spaceInDays: Number(spaceInDays),
        weeksCount:
          (periodDayCounts.find(({ id }) => id === detailedPeriod)?.daysCount ||
            7) / 7,
      },
      startDate,
      renderedMonths,
    });
  } else if (primaryPeriod === WS_WEEKS) {
    period = getDatesByPattern({
      mode: WS_WEEKS,
      pattern: {
        specificDays: handleSpecificDays(selectedDays),
        weeksCount:
          (periodDayCounts.find(({ id }) => id === detailedPeriod)?.daysCount ||
            7) / 7,
      } as NWorkSchedule.Weeks,
      startDate,
      renderedMonths,
    });
  }
  return period;
};
